import { createSelector } from '@reduxjs/toolkit';

import { TAvailableActions } from '../../types/availableActions';
import { TOpenedChat } from '../../types/openedChats';
import { IUserInChatListSchema } from '../../types/userData';
import { chatListSelector } from '../chatListSelector';
import { currentOpenChatIDSelector } from '../currentOpenChatIDSelector';
import { openedChatsSelector } from '../openedChatsSelector';

export type TCurrentOpenedChat = TOpenedChat & {
  blocked?: boolean;
  availableActions?: TAvailableActions[] | null;
  users: IUserInChatListSchema[];
  botId?: number | null;
  isStarred?: boolean | null;
};

const selectCurrentChatListItem = createSelector([chatListSelector, currentOpenChatIDSelector], (chatList, chatId) =>
  chatList.chats.find(chat => chat.chatId === chatId),
);

export const currentOpenChatSelector = createSelector(
  [openedChatsSelector, currentOpenChatIDSelector, selectCurrentChatListItem],
  (openedChats, currentOpenedChatId, currentChatListItem): TCurrentOpenedChat | null => {
    const currentChat = currentOpenedChatId !== undefined && openedChats[currentOpenedChatId];

    if (!currentChat) {
      return null;
    }

    const blocked = currentChatListItem ? currentChatListItem.status === 'blocked' : undefined;
    const availableActions = currentChatListItem ? currentChatListItem.availableActions : null;
    const users = currentChatListItem?.users ?? currentChat.users ?? [];
    const botId = currentChatListItem ? currentChatListItem.botId : undefined;
    const isStarred = currentChatListItem ? currentChatListItem.isStarred : undefined;

    return { ...currentChat, blocked, availableActions, users, botId, isStarred };
  },
);
